// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Charts from '../Charts';
import StatusTable from '../SuccessCard/StatusTable';
import { getFormattedGranularity } from '../../utils/helperMethods';

// Component
import { ChartNoData } from '..';

// Styles
import './failureCard.scss';

/**
 * FailureCard Component
 *
 * @param {Object} data - React component
 * @param {string} customClass - React className
 */

const FailureCard = ({ customClass, tabData }) => {
    const {
        absoluteValues,
        granularity,
        tableValues,
        timeSeriesValues,
    } = tabData;
    const columns = React.useMemo(
        () => [
            { header: 'Failure Reasons', accessor: 'aggregator' },
            {
                header: 'Number of Failures',
                accessor: 'values.FAILED_TRANSACTION_COUNT',
                id: 'transactionCount',
            },
            {
                header: 'Bucket Rate',
                accessor: 'values.BUCKET_RATE',
                id: 'percentage',
            },
        ],
        []
    );
    const legendsList = [
        {
            label: 'Failures',
            color: '#ff0000',
        },
    ];

    return (
        <div className={`failure-card' ${customClass || ''} `}>
            {isEmpty(tableValues) && isEmpty(timeSeriesValues) ? (
                <ChartNoData title="No data available" />
            ) : (
                <>
                    <div className="card-chart">
                        <div className="chart-status">
                            <ul className="status-list">
                                <li>
                                    <label>FAILED TRANSACTION</label>
                                    <p>
                                        {absoluteValues &&
                                            `${absoluteValues.FAILED_TRANSACTION_COUNT ||
                                                '-'}`}
                                        {/* <span className="indicator">0.34%</span> */}
                                    </p>
                                </li>
                                <li>
                                    <label>FAILURE RATE</label>
                                    <p>
                                        {absoluteValues &&
                                            `${absoluteValues.FAILURE_RATE ||
                                                '-'} %`}
                                        {/* <span className="indicator">0.34%</span> */}
                                    </p>
                                </li>
                            </ul>
                            <div className="chart-legends">
                                {legendsList && (
                                    <ul className="legends-list">
                                        {legendsList.map(item => (
                                            <li>
                                                <span
                                                    className="brick"
                                                    style={{
                                                        background: `${item.color}`,
                                                    }}
                                                />
                                                <span className="legend-text">
                                                    {item.label}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <Charts
                            type="line"
                            data={getFormattedGranularity(
                                timeSeriesValues,
                                granularity
                            )}
                            legends={{
                                FAILED_TRANSACTION_COUNT: {
                                    label: 'Failures',
                                    color: '#ff0000',
                                },
                            }}
                        />
                    </div>
                    {!isEmpty(tableValues) ? (
                        <div className="card-table">
                            <StatusTable
                                customClass="custom-table"
                                columns={columns}
                                data={tableValues}
                                initialState={{
                                    sortBy: [
                                        {
                                            id: 'transactionCount',
                                            desc: true,
                                        },
                                    ],
                                }}
                            />
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
};

FailureCard.propTypes = {
    customClass: PropTypes.string,
    tabData: PropTypes.object,
};

export default FailureCard;
